import { Button }       from '@/components/ui/button';
import { DialogBody }   from '@/components/ui/dialog';
import { DialogContent } from '@/components/ui/dialog';
import { DialogFooter } from '@/components/ui/dialog';
import { DialogHeader } from '@/components/ui/dialog';
import { DialogRoot }   from '@/components/ui/dialog';
import { DialogTitle }  from '@/components/ui/dialog';
import { useTranslation } from 'react-i18next';

interface ISendToValidationModalProps {
	isOpen: boolean;
	onClose: () => void;
	onConfirm: () => void;
}

const SendToValidationModal = ({ isOpen, onClose, onConfirm }: ISendToValidationModalProps) => {
	const { t } = useTranslation();

	return (
		<DialogRoot role="alertdialog" open={isOpen}>
			<DialogContent>
				<DialogHeader>
					<DialogTitle>{t('pages.editStand.form.actions.confirmSendToValidation.title')}</DialogTitle>
				</DialogHeader>
				<DialogBody>
					<p>{t('pages.editStand.form.actions.confirmSendToValidation.message')}</p>
				</DialogBody>
				<DialogFooter>
					<Button variant="outline" onClick={onClose}>
						{t('app.actions.cancel')}
					</Button>
					<Button
						bg="black"
						color="white"
						_hover={{ bg: 'gray.800' }}
						onClick={onConfirm}
					>
						{t('pages.editStand.form.actions.saveAndSendToValidation')}
					</Button>
				</DialogFooter>
			</DialogContent>
		</DialogRoot>
	);
};

export default SendToValidationModal;
